var _style, _g, _rect, _rect2, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon, _polygon2, _path13, _path14, _path15, _line, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon3, _polygon4, _path25, _path26, _path27, _path28, _path29, _path30, _polygon5, _polygon6, _path31, _path32, _polygon7, _polygon8, _path33, _path34, _g4, _path35, _path36, _g5, _g6, _path37, _path38, _g7, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMylogocolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 251.9 193.2",
    style: {
      enableBackground: "new 0 0 251.9 193.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3C8FFC;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:#000002;}\r\n\t.st4{fill:url(#SVGID_00000152977771296751640830000003372711618093463974_);}\r\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st7{opacity:0.8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-503.3,661c3.5,4.3,7.2,7.5,10.3,9.8c1.1,0.9,2.5,1.9,4.1,3c7,4.7,17.8,10.7,31.7,13.4 c3.8,0.7,7.9,1.2,12.1,1.3c7.9,0.3,14.7-0.6,20.4-1.9c7.2-1.3,17.1-4.1,27.5-10.3c21.6-13,31.1-32.6,34.3-40.6 c0,0-14.4,18.6-25.3,26.4l0-119.7c-7-4.8-17.8-10.7-31.7-13.5v70.6H-438l-0.9,17.1h19.7v38.9c-1.6,2-4,4.8-7.4,7.4 c-10.1,7.5-21.1,7.9-26.3,8.1c-1.5,0-2.9,0-4.3-0.1c-8.4-0.4-15-2.9-21.8-5.5c-2.8-1.1-6.2-2.5-10-4.4 c-7.2-3.5-15.7-8.8-24.6-16.2C-511.5,649.2-508.4,655.1-503.3,661z"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 84,
    xlinkHref: "53F4F66D.png",
    transform: "matrix(1 0 0 1 266.1786 542.25)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 269.1,
    className: "st0",
    width: 110.2,
    height: 110.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 269.1,
    className: "st1",
    width: 110.2,
    height: 110.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,120.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2189.1,1154.1c-4-62-7-152-7-199v-87l350-218l350-217v-184c0-100,1-183,3-183c1,0,61,24,132,54l130,55l3,203l2,203 l-352,216l-353,215l-3,127l-3,127h-123h-123L2189.1,1154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2882.1,1078.1v-187l125-63c69-34,130-62,135-62c6,0,10,92,10,250v250h-135h-135V1078.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2182.1,437.1v-258l127-56l128-56l3,231c2,177-1,235-10,244c-7,6-66,43-130,82l-118,71V437.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "279.7,146 350.2,189.1 350.2,240.5 323.5,240.6 323.2,203.9 253.2,160.4 253.2,120.6 279.1,120.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.3,120.6 348.3,120.6 348.3,171.9 321.3,158.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.2,177.7 278,193 278.7,240.5 253.2,240.5  "
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 123,
    height: 117,
    xlinkHref: "C:\\\\\\\\Users\\\\\\\\hansr\\\\\\\\Pictures\\\\\\\\Screenshots\\\\\\\\Screenshot (9).png",
    transform: "matrix(0.75 0 0 0.75 63.5893 156.9643)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -61.4402,
    y1: 35.7966,
    x2: -60.3077,
    y2: 91.4005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#238AC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04799851,
    style: {
      stopColor: "#1482C4",
      stopOpacity: 0.9487
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1145,
    style: {
      stopColor: "#097CC1",
      stopOpacity: 0.8777
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2081,
    style: {
      stopColor: "#0278BF",
      stopOpacity: 0.7777
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4679,
    style: {
      stopColor: "#0077BF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0077BF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-20.6,40.6c-0.7-1.5-1.5-3.1-2.6-4.9c-1.6-2.5-3.3-4.6-4.8-6.2c-2.1-2-4.7-4.2-7.9-6.2 c-7.9-4.8-15.5-6.3-20.3-6.7c-2.4-0.3-5.2-0.4-8.2-0.1c-9.7,0.7-17.1,4.3-21.6,7.1c-2.6,1.8-5.7,4.3-8.8,7.6 c-4.8,5.2-7.6,10.4-9.3,14.3l14-14.6l0.2,62.5c5.8,1.2,11.6,2.4,17.4,3.6c0-10.5,0.1-20.9,0.1-31.4h23.3v23.1c0,0-6.5,8.8-28,6.5 c-1.6-0.4-3.7-1-6-1.9c-2.2-0.9-5.3-2.3-8.7-4.7c-4.6-3.1-7.8-6.7-10-9.5c0.6,1.5,1.3,3.1,2.1,4.9c0.8,1.7,1.9,3.6,3.1,5.5 c1.6,2.5,3.3,4.7,4.3,5.8c4.8,5.5,11.8,8.5,13.9,9.4c9.8,4,18.5,3,22.3,2.5c1.9-0.2,7.7-1.1,14.4-4.1c4.8-2.2,8-4.6,8.7-5.1 c3.3-2.5,5.4-5,6.6-6.3c2-2.3,3.3-4.2,4.2-5.5c1.3-2,3-4.7,4.6-8c-4.6,4.3-9.2,8.6-13.8,12.9V28.5c-6.1-1-12.2-2-18.4-3 c0.1,10.2,0.2,20.4,0.2,30.6h-10.5h-12.5V34.6c1.9-1.8,5.4-4.6,10.6-6.4c6.4-2.2,11.9-1.6,14.6-1.1c1.6,0.1,3.9,0.3,6.6,1 c5.2,1.3,8.8,3.7,12.4,6.1C-26.5,35.6-23.7,37.7-20.6,40.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-148.9,221.6c2.5,1,5,1.9,7.8,2.5h-12.4v-4.5C-151.7,220.4-150.2,221-148.9,221.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-98.5,155.6v4.5c-1.7-0.8-3.2-1.5-4.6-2c-2.5-1-5-1.9-7.8-2.5H-98.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-84.5,205.2c-1.8,4.4-7,15.3-19,22.5c-5.8,3.5-11.3,5-15.2,5.7c-3.1,0.7-7,1.2-11.3,1.1 c-12.9-0.5-22.3-6.6-26.6-9.8c-1.7-1.3-3.8-3.1-5.7-5.5c-2.8-3.3-4.5-6.6-5.6-9c5.3,4.5,10.4,7.5,14.5,9.5v4.5h12.4 c2,0.4,4.2,0.7,6.7,0.6c2.9-0.1,9-0.3,14.5-4.5c1.9-1.4,3.3-3,4.1-4.1v-21.6h-20.1v29.5h-5.2c-2.8-0.6-5.2-1.5-7.8-2.5 c-1.4-0.5-2.9-1.2-4.6-2v-59.7c-6,4.3-14,14.6-14,14.6c1.8-4.4,7-15.3,19-22.5c5.8-3.5,11.3-5,15.2-5.7c3.1-0.7,7-1.2,11.3-1.1 c12.9,0.5,22.3,6.6,26.6,9.8c1.7,1.3,3.7,3.1,5.7,5.5c2.8,3.3,4.5,6.6,5.6,9c-5.3-4.5-10.4-7.5-14.5-9.5v-4.5h-12.4 c-2-0.4-4.2-0.7-6.6-0.6c-2.9,0.1-9,0.3-14.5,4.5c-1.9,1.4-3.3,3-4.1,4.1v21.6h20.1v-29.5h5.2c2.8,0.6,5.2,1.5,7.8,2.5 c1.3,0.5,2.9,1.2,4.6,2v59.7C-92.5,215.5-84.5,205.2-84.5,205.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-148.9,221.6c2.5,1,5,1.9,7.8,2.5h-12.4v-4.5C-151.7,220.4-150.2,221-148.9,221.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-98.5,155.6v4.5c-1.7-0.8-3.2-1.5-4.6-2c-2.5-1-5-1.9-7.8-2.5H-98.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-45.6,363.4c-1.8,4.4-7,15.3-19,22.5c-5.8,3.5-11.3,5-15.2,5.7c-2.1,0.5-4.5,0.9-7.2,1c-1.3,0.1-2.7,0.1-4.1,0 c-12.9-0.5-22.3-6.6-26.6-9.8c-1.7-1.3-3.8-3.1-5.7-5.4c-2.8-3.3-4.5-6.6-5.6-9c5.3,4.5,10.4,7.5,14.5,9.5c1.7,0.8,3.2,1.5,4.6,2 c2.5,1,5,1.9,7.8,2.5c2,0.4,4.2,0.7,6.7,0.6c1.8,0,5-0.2,8.4-1.3c2-0.6,4.1-1.6,6.1-3.2c1.9-1.4,3.3-3,4.1-4.1v-21.6h-10.2v-9.5h9.9 v-29.5h5.2c2.8,0.6,5.2,1.5,7.8,2.5c1.3,0.5,2.9,1.2,4.6,2v59.7C-53.6,373.7-45.6,363.4-45.6,363.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-45.1,327.8c-5.3-4.5-10.4-7.5-14.5-9.5c-1.7-0.8-3.2-1.5-4.6-2c-2.5-1-5-1.9-7.8-2.5c-2-0.4-4.2-0.7-6.6-0.6 c-1.8,0-5,0.2-8.4,1.3c-2,0.7-4.1,1.6-6.1,3.2c-1.9,1.4-3.3,3-4.1,4.1v21.6h10.2v9.5H-97v29.5h-5.2c-2.8-0.6-5.2-1.5-7.8-2.5 c-1.4-0.5-2.9-1.2-4.6-2v-59.7c-6,4.3-14,14.6-14,14.6c1.8-4.4,7-15.3,19-22.5c5.8-3.5,11.3-5,15.2-5.7c2.1-0.5,4.5-0.9,7.2-1 c1.3-0.1,2.6-0.1,4.1,0c12.9,0.5,22.3,6.6,26.6,9.8c1.7,1.3,3.7,3.1,5.7,5.5C-47.9,322.1-46.2,325.4-45.1,327.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-222.3,196.1h-10.9v-21.6c0.8-1.1,2.2-2.6,4.1-4.1c5.6-4.2,11.7-4.4,14.5-4.5c5.8-0.1,10,1.4,14.4,3.1 c4.7,1.8,11.7,5.1,19.1,11.4c-1.1-2.5-2.8-5.7-5.6-9c-2-2.3-4-4.1-5.7-5.4c-4.3-3.2-13.7-9.3-26.6-9.8c-4.3-0.2-8.2,0.4-11.3,1.1 c-4,0.7-9.5,2.3-15.2,5.7c-12,7.2-17.2,18.1-19,22.5c0,0,8-10.3,14-14.6v64.2h17.6v-29.5h10.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-222.8,205.6h10.9v21.6c-0.8,1.1-2.2,2.6-4.1,4.1c-5.6,4.2-11.7,4.4-14.5,4.5c-5.8,0.1-10-1.4-14.4-3.1 c-4.7-1.8-11.7-5.1-19.1-11.4c1.1,2.5,2.8,5.7,5.6,9c2,2.3,4,4.1,5.7,5.4c4.3,3.2,13.7,9.3,26.6,9.8c4.3,0.2,8.2-0.4,11.3-1.1 c4-0.7,9.5-2.3,15.2-5.7c12-7.2,17.2-18.1,19-22.5c0,0-8,10.3-14,14.6v-64.2h-17.6v29.5h-10.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.4,356.9h-2.6v-5.2c0.2-0.3,0.5-0.6,1-1c1.3-1,2.8-1.1,3.5-1.1c1.4,0,2.4,0.3,3.5,0.8 c1.1,0.4,2.8,1.2,4.6,2.8c-0.3-0.6-0.7-1.4-1.4-2.2c-0.5-0.6-1-1-1.4-1.3c-1-0.8-3.3-2.3-6.4-2.4c-1,0-2,0.1-2.7,0.3 c-1,0.2-2.3,0.5-3.7,1.4c-2.9,1.7-4.1,4.4-4.6,5.4c0,0,1.9-2.5,3.4-3.5v15.5h4.2v-7.1h2.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.3,359.2h2.6v5.2c-0.2,0.3-0.5,0.6-1,1c-1.3,1-2.8,1.1-3.5,1.1c-1.4,0-2.4-0.3-3.5-0.8 c-1.1-0.4-2.8-1.2-4.6-2.8c0.3,0.6,0.7,1.4,1.4,2.2c0.5,0.6,1,1,1.4,1.3c1,0.8,3.3,2.3,6.4,2.4c1,0,2-0.1,2.7-0.3 c1-0.2,2.3-0.5,3.7-1.4c2.9-1.7,4.1-4.4,4.6-5.4c0,0-1.9,2.5-3.4,3.5v-15.5h-4.2v7.1h-2.4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "99.9,356.9 99.8,359.2 99.7,359.2 99.9,356.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "99.9,356.9 99.8,359.2 99.7,359.2 99.9,356.9 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028326424966887748270000014623173541078192056_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.7711,
    y1: 74.5339,
    x2: 102.2121,
    y2: 74.5339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#238AC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04799851,
    style: {
      stopColor: "#1482C4",
      stopOpacity: 0.9487
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1145,
    style: {
      stopColor: "#097CC1",
      stopOpacity: 0.8777
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2081,
    style: {
      stopColor: "#0278BF",
      stopOpacity: 0.7777
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4679,
    style: {
      stopColor: "#0077BF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0077BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028326424966887748270000014623173541078192056_)"
    },
    d: "M60,74.1h10.9v21.6 c-0.8,1.1-2.2,2.6-4.1,4.1c-5.6,4.2-11.7,4.4-14.5,4.5c-5.8,0.1-10-1.4-14.4-3.1c-4.7-1.8-11.7-5.1-19.1-11.4c1.1,2.5,2.8,5.7,5.6,9 c2,2.3,4,4.1,5.7,5.4c4.3,3.2,13.7,9.3,26.6,9.8c4.3,0.2,8.2-0.4,11.3-1.1c4-0.7,9.5-2.3,15.2-5.7c12-7.2,17.2-18.1,19-22.5 c0,0-8,10.3-14,14.6V35.1H70.6v29.5H60.5"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.7,50.8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.8,160.2c0.3-2.4,1.3-3.9,2.5-5.3c1.1-1.4,2.5-2.6,4-3.6c1.4-0.9,3-1.6,4.6-2.1c2.8-0.8,5.8-1,8.6-0.4 c0.3,0.1,0.6,0.2,1,0.2c1.6,0.5,3.1,1.2,4.5,2.1c1.4,0.9,2.6,2,3.6,3.3c0.5,0.6,1,1.3,1.4,2c0.2,0.4,0.4,0.7,0.6,1.1 c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.1,0.1,0.4,0.2,0.5c-0.3-0.5-0.7-0.9-1-1.3c-0.4-0.4-0.7-0.8-1.1-1.2c-1.3-1.2-2.7-2.2-4.3-3 c-1.6-0.7-3.2-1.1-5-1.2c-2.5,0-5.1,0.9-7,2.5c-0.2,0.2-0.5,0.4-0.6,0.7c-0.1,0.2-0.1,0.5-0.1,0.7c0,9.6,0,19.2,0,28.8 c-2,0-4,0-6.1,0c0-9.9,0-19.9,0-29.8C15.9,154.9,13.6,153.8,9.8,160.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-29.9,188.5v-29.6c0,0,9.5-9.3,19.4,4c-0.3-0.4-0.4-1-0.7-1.4c-0.6-1.2-1.3-2.3-2.2-3.3 c-1.1-1.4-2.4-2.6-3.9-3.6c-1.7-1.2-3.7-1.9-5.8-2.3c-2.6-0.4-5.3-0.1-7.9,0.6c-0.8,0.2-1.6,0.5-2.4,0.8c-1.3,0.5-2.6,1.2-3.7,2.2 c-1.1,1-2.1,2.1-2.9,3.2c-0.8,1.1-1.5,2.5-1.6,3.9c0,0,3.8-5.5,5.4-4.8v30.2H-29.9z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 122.7,
    y1: 186.7,
    x2: 95.7,
    y2: 186.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-16.3,290.1V270c-0.2-0.1-0.3-0.2-0.5-0.2c-0.5-0.2-1-0.5-1.6-0.7c-0.9-0.3-1.7-0.7-2.6-0.8 c-0.5-0.1-1.1-0.2-1.6-0.2v9.7h-7.2v-7.7c0.3-0.4,0.8-0.9,1.5-1.4c0.7-0.5,1.5-0.9,2.2-1.1c1.2-0.4,2.4-0.5,3-0.5 c0.9,0,1.6,0.1,2.4,0.2c1,0.2,1.9,0.5,2.8,0.9c0.5,0.2,1,0.4,1.6,0.7c1.5,0.7,3.3,1.8,5.2,3.4c-0.4-0.9-1-2-2-3.2 c-0.7-0.8-1.4-1.5-2-1.9c-1.5-1.2-4.9-3.3-9.5-3.5c-0.5,0-1,0-1.4,0c-1,0.1-1.8,0.2-2.6,0.4c-1.4,0.3-3.4,0.8-5.4,2 c-4.3,2.6-6.1,6.4-6.8,8c0,0,2.9-3.7,5-5.2v20.1c0.2,0.1,0.3,0.2,0.5,0.2c0.5,0.2,1,0.5,1.6,0.7c0.9,0.3,1.7,0.7,2.6,0.8 c0.5,0.1,1.1,0.2,1.6,0.2v-9.7h7.2v7.7c-0.3,0.4-0.8,0.9-1.5,1.4c-0.7,0.5-1.5,0.9-2.2,1.1c-1.2,0.4-2.4,0.5-3,0.5 c-0.9,0-1.7-0.1-2.4-0.2c-1-0.2-1.9-0.5-2.8-0.9c-0.5-0.2-1-0.4-1.6-0.7c-1.5-0.7-3.3-1.8-5.2-3.4c0.4,0.9,1,2,2,3.2 c0.7,0.8,1.4,1.5,2,1.9c1.5,1.2,4.9,3.3,9.5,3.5c0.5,0,1,0,1.4,0c1-0.1,1.8-0.2,2.6-0.4c1.4-0.3,3.4-0.8,5.4-2 c4.3-2.6,6.1-6.4,6.8-8C-11.3,284.9-14.2,288.6-16.3,290.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.6,322.7v-20.1c-0.2-0.1-0.3-0.2-0.5-0.2c-0.5-0.2-1-0.5-1.6-0.7c-0.9-0.3-1.7-0.7-2.6-0.8 c-0.5-0.1-1.1-0.2-1.6-0.2v9.7h-7.2v-7.7c0.3-0.4,0.8-0.9,1.5-1.4c0.7-0.5,1.5-0.9,2.2-1.1c1.2-0.4,2.4-0.5,3-0.5 c0.9,0,1.6,0.1,2.4,0.2c1,0.2,1.9,0.5,2.8,0.9c0.5,0.2,1,0.4,1.6,0.7c1.5,0.7,3.3,1.8,5.2,3.4c-0.4-0.9-1-2-2-3.2 c-0.7-0.8-1.4-1.5-2-1.9c-1.5-1.2-4.9-3.3-9.5-3.5c-0.5,0-1,0-1.4,0c-1,0.1-1.8,0.2-2.6,0.4c-1.4,0.3-3.4,0.8-5.4,2 c-4.3,2.6-6.1,6.4-6.8,8c0,0,2.9-3.7,5-5.2v20.1c0.2,0.1,0.3,0.2,0.5,0.2c0.5,0.2,1,0.5,1.6,0.7c0.9,0.3,1.7,0.7,2.6,0.8 c0.5,0.1,1.1,0.2,1.6,0.2v-9.7h7.2v7.7c-0.3,0.4-0.8,0.9-1.5,1.4c-0.7,0.5-1.5,0.9-2.2,1.1c-1.2,0.4-2.4,0.5-3,0.5 c-0.9,0-1.7-0.1-2.4-0.2c-1-0.2-1.9-0.5-2.8-0.9c-0.5-0.2-1-0.4-1.6-0.7c-1.5-0.7-3.3-1.8-5.2-3.4c0.4,0.9,1,2,2,3.2 c0.7,0.8,1.4,1.5,2,1.9c1.5,1.2,4.9,3.3,9.5,3.5c0.5,0,1,0,1.4,0c1-0.1,1.8-0.2,2.6-0.4c1.4-0.3,3.4-0.8,5.4-2 c4.3-2.6,6.1-6.4,6.8-8C114.6,317.5,111.7,321.2,109.6,322.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252,589.1v44.8h41.7v-56.3c3.2,0.1,6.4,0.5,9.5,1.2c5.2,1.1,10,3,15.3,4.9c3,1.1,6,2.5,9.1,3.9 c0.9,0.4,1.8,0.9,2.7,1.3V706l-35.9-7.6v-44.8h-41.7V710c-3.2-0.1-6.4-0.5-9.5-1.1c-5.2-1.1-10-3-15.2-4.9c-3-1.2-6.1-2.5-9.1-3.9 c-0.9-0.4-1.8-0.9-2.7-1.3V581.5c-12.3,8.8-28.6,29.7-29.1,30.4c3.8-9.2,14.6-31.7,39.5-46.7c12-7.2,23.4-10.4,31.7-11.9 c4.4-1,9.4-1.8,15-2.1c2.7-0.1,5.5-0.2,8.4-0.1c26.8,1,46.4,13.7,55.2,20.4c3.6,2.8,7.8,6.5,11.9,11.3c5.8,6.9,9.4,13.6,11.7,18.8 c-11-9.3-21.5-15.5-30.2-19.7c-3.5-1.7-6.7-3-9.5-4.1c-5.3-2-10.5-4-16.2-5.2c-4.2-0.9-8.7-1.4-13.8-1.3c-3.8,0.1-10.3,0.3-17.5,2.7 c-4.1,1.4-8.5,3.4-12.7,6.6C256.6,583.6,253.8,586.8,252,589.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.5,322.7v-20.1c-0.2-0.1-0.3-0.2-0.5-0.2c-0.5-0.2-1-0.5-1.6-0.7c-0.9-0.3-1.7-0.7-2.6-0.8 c-0.5-0.1-1.1-0.2-1.6-0.2v9.7h-7.2v-7.7c0.3-0.4,0.8-0.9,1.5-1.4c0.7-0.5,1.5-0.9,2.2-1.1c1.2-0.4,2.4-0.5,3-0.5 c0.9,0,1.6,0.1,2.4,0.2c1,0.2,1.9,0.5,2.8,0.9c0.5,0.2,1,0.4,1.6,0.7c1.5,0.7,3.3,1.8,5.2,3.4c-0.4-0.9-1-2-2-3.2 c-0.7-0.8-1.4-1.5-2-1.9c-1.5-1.2-4.9-3.3-9.5-3.5c-0.5,0-1,0-1.4,0c-1,0.1-1.8,0.2-2.6,0.4c-1.4,0.3-3.4,0.8-5.4,2 c-4.3,2.6-6.1,6.4-6.8,8c0,0,2.9-3.7,5-5.2v20.1c0.2,0.1,0.3,0.2,0.5,0.2c0.5,0.2,1,0.5,1.6,0.7c0.9,0.3,1.7,0.7,2.6,0.8 c0.5,0.1,1.1,0.2,1.6,0.2v-9.7h7.2v7.7c-0.3,0.4-0.8,0.9-1.5,1.4c-0.7,0.5-1.5,0.9-2.2,1.1c-1.2,0.4-2.4,0.5-3,0.5 c-0.9,0-1.7-0.1-2.4-0.2c-1-0.2-1.9-0.5-2.8-0.9c-0.5-0.2-1-0.4-1.6-0.7c-1.5-0.7-3.3-1.8-5.2-3.4c0.4,0.9,1,2,2,3.2 c0.7,0.8,1.4,1.5,2,1.9c1.5,1.2,4.9,3.3,9.5,3.5c0.5,0,1,0,1.4,0c1-0.1,1.8-0.2,2.6-0.4c1.4-0.3,3.4-0.8,5.4-2 c4.3-2.6,6.1-6.4,6.8-8C75.5,317.5,72.6,321.2,70.5,322.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.8,353.1c-1.2-1-2.3-1.7-3.3-2.2c-0.5-0.2-1-0.4-1.3-0.6c-0.9-0.3-1.8-0.7-2.9-0.7v-2.2 c1.9,0.4,3.3,1.2,4.2,1.8c0.2,0.1,0.4,0.3,0.5,0.4c0.4,0.3,0.9,0.7,1.4,1.3C109.1,351.7,109.6,352.5,109.8,353.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.8,362.9c1.2,1,2.3,1.7,3.3,2.2v1.7c-0.2-0.1-0.4-0.3-0.5-0.4c-0.4-0.3-0.9-0.7-1.4-1.3 C90.5,364.3,90,363.5,89.8,362.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.9,361.7c-0.4,1.1-1.7,3.7-4.6,5.4c-1.4,0.8-2.7,1.2-3.7,1.4c-0.8,0.2-1.7,0.3-2.7,0.2 c-0.6,0-1.1-0.1-1.6-0.2v-2.2c0.2,0,0.4,0,0.6,0c0.7,0,2.2-0.1,3.5-1.1c0.5-0.3,0.8-0.7,1-1v-5.2h-2.6l0.1-2.3h2.4v-9.4 c1.9,0.4,3.3,1.2,4.2,1.8v16C108,364.2,109.9,361.7,109.9,361.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.8,353.1c-1.2-1-2.3-1.7-3.3-2.2c-0.5-0.2-1-0.4-1.3-0.6c-0.9-0.3-1.8-0.7-2.9-0.7v-2.2 c1.9,0.4,3.3,1.2,4.2,1.8c0.2,0.1,0.4,0.3,0.5,0.4c0.4,0.3,0.9,0.7,1.4,1.3C109.1,351.7,109.6,352.5,109.8,353.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.5,350.9c-0.5-0.6-1-1-1.4-1.3c-0.1-0.1-0.3-0.3-0.5-0.4c-0.9-0.6-2.4-1.4-4.2-1.8c-0.5-0.1-1-0.2-1.6-0.2 c-1,0-2,0.1-2.7,0.2c-1,0.2-2.3,0.5-3.7,1.4c-2.9,1.7-4.2,4.4-4.6,5.4c0,0,1.9-2.5,3.4-3.5v16c0.9,0.6,2.4,1.4,4.2,1.8v-9.4h2.4 l0.1-2.3h-2.6v-5.2c0.2-0.3,0.5-0.6,1-1c1.4-1,2.8-1.1,3.5-1.1c0.2,0,0.4,0,0.6,0c1.1,0.1,2,0.4,2.9,0.7c0.4,0.2,0.8,0.3,1.3,0.6 c1,0.5,2.1,1.2,3.3,2.2C109.6,352.5,109.1,351.7,108.5,350.9z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "94.9,393.1 94.8,395.4 94.8,395.4 94.9,393.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "94.9,393.1 94.8,395.4 94.8,395.4 94.9,393.1 "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.9,389.3c-1.2-1-2.3-1.7-3.3-2.2c-0.5-0.2-1-0.4-1.3-0.6c-0.9-0.3-1.8-0.7-2.9-0.7v-2.2 c1.9,0.4,3.3,1.2,4.2,1.8c0.2,0.1,0.4,0.3,0.5,0.4c0.4,0.3,0.9,0.7,1.4,1.3C104.2,388,104.6,388.7,104.9,389.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.9,399.1c1.2,1,2.3,1.7,3.3,2.2v1.7c-0.2-0.1-0.4-0.3-0.5-0.4c-0.4-0.3-0.9-0.7-1.4-1.3 C85.5,400.5,85.1,399.7,84.9,399.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105,397.9c-0.4,1.1-1.7,3.7-4.6,5.4c-1.4,0.8-2.7,1.2-3.7,1.4C96,404.9,95,405,94,405c-0.6,0-1.1-0.1-1.6-0.2 v-2.2c0.2,0,0.4,0,0.6,0c0.7,0,2.2-0.1,3.5-1.1c0.5-0.3,0.8-0.7,1-1v-5.2h-2.6l0.1-2.3h2.4v-9.4c1.9,0.4,3.3,1.2,4.2,1.8v16 C103.1,400.4,105,397.9,105,397.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.9,389.3c-1.2-1-2.3-1.7-3.3-2.2c-0.5-0.2-1-0.4-1.3-0.6c-0.9-0.3-1.8-0.7-2.9-0.7v-2.2 c1.9,0.4,3.3,1.2,4.2,1.8c0.2,0.1,0.4,0.3,0.5,0.4c0.4,0.3,0.9,0.7,1.4,1.3C104.2,388,104.6,388.7,104.9,389.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.5,387.2c-0.5-0.6-1-1-1.4-1.3c-0.1-0.1-0.3-0.3-0.5-0.4c-0.9-0.6-2.4-1.4-4.2-1.8c-0.5-0.1-1-0.2-1.6-0.2 c-1,0-2,0.1-2.7,0.2c-1,0.2-2.3,0.5-3.7,1.4c-2.9,1.7-4.2,4.4-4.6,5.4c0,0,1.9-2.5,3.4-3.5v16c0.9,0.6,2.4,1.4,4.2,1.8v-9.4h2.4 l0.1-2.3h-2.6v-5.2c0.2-0.3,0.5-0.6,1-1c1.4-1,2.8-1.1,3.5-1.1c0.2,0,0.4,0,0.6,0c1.1,0.1,2,0.4,2.9,0.7c0.4,0.2,0.8,0.3,1.3,0.6 c1,0.5,2.1,1.2,3.3,2.2C104.6,388.7,104.2,388,103.5,387.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.3,349.6c0,0,2.1,0.2,4.2,1.3v0.5l-4.2-0.7V349.6z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-132.2,519 -133,536.1 -133.2,536.1 -132.3,519 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-132.2,519 -133,536.1 -133.2,536.1 -132.3,519 "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-57.7,491c-8.9-7.5-17.4-12.7-24.6-16.2c-3.7-1.9-7.1-3.3-10-4.4c-6.8-2.6-13.4-5.1-21.8-5.5v-16.3 c13.9,2.7,24.8,8.7,31.7,13.4c1.6,1,3,2.1,4.1,3c3.1,2.3,6.8,5.5,10.3,9.8C-62.8,480.6-59.6,486.5-57.7,491z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-57.7,491c-8.9-7.5-17.4-12.7-24.6-16.2c-3.7-1.9-7.1-3.3-10-4.4c-6.8-2.6-13.4-5.1-21.8-5.5v-16.3 c13.9,2.7,24.8,8.7,31.7,13.4c1.6,1,3,2.1,4.1,3c3.1,2.3,6.8,5.5,10.3,9.8C-62.8,480.6-59.6,486.5-57.7,491z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-436.9,599.5 -437.8,616.7 -437.9,616.7 -437,599.5 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-436.9,599.5 -437.8,616.7 -437.9,616.7 -437,599.5 "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-362.4,571.5c-8.9-7.5-17.4-12.7-24.6-16.2c-3.7-1.9-7.1-3.3-10-4.4c-6.8-2.6-13.4-5.1-21.8-5.5V529 c13.9,2.7,24.8,8.7,31.7,13.4c1.6,1,3,2.1,4.1,3c3.1,2.3,6.8,5.5,10.3,9.8C-367.5,561.2-364.4,567-362.4,571.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-362.4,571.5c-8.9-7.5-17.4-12.7-24.6-16.2c-3.7-1.9-7.1-3.3-10-4.4c-6.8-2.6-13.4-5.1-21.8-5.5V529 c13.9,2.7,24.8,8.7,31.7,13.4c1.6,1,3,2.1,4.1,3c3.1,2.3,6.8,5.5,10.3,9.8C-367.5,561.2-364.4,567-362.4,571.5z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-372.6,555.2c-3.5-4.3-7.2-7.5-10.3-9.8c-1.1-0.9-2.5-1.9-4.1-3c-7-4.7-17.8-10.7-31.7-13.4 c-3.8-0.7-7.9-1.2-12.1-1.3c-7.9-0.3-14.7,0.6-20.4,1.9c-7.2,1.3-17.1,4.1-27.5,10.3c-21.6,13-31.1,32.6-34.3,40.6 c0,0,14.4-18.6,25.3-26.4v119.7c7,4.8,17.8,10.7,31.7,13.5v-70.6h18.2l0.9-17.1h-19.7v-38.9c1.6-2,4-4.8,7.4-7.4 c10.1-7.5,21.1-7.9,26.3-8.1c1.5,0,2.9,0,4.3,0.1c8.4,0.4,15,2.9,21.8,5.5c2.8,1.1,6.2,2.5,10,4.4c7.2,3.5,15.7,8.8,24.6,16.2 C-364.4,567-367.5,561.2-372.6,555.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.7
    },
    width: 114,
    height: 99,
    xlinkHref: "53F4F66A.png",
    transform: "matrix(1 0 0 1 -374.6071 729.459)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 57,
    height: 45,
    xlinkHref: "53F4F66B.png",
    transform: "matrix(1.0772 0 0 1.0772 -349.4018 753.472)"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 84,
    xlinkHref: "53F4F675.png",
    transform: "matrix(1 0 0 1 -46 494.1454)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.4,675.6c-3.8,9.2-14.6,31.7-39.4,46.7c-12,7.2-23.4,10.4-31.7,11.9c-4.4,1-9.4,1.8-15,2.1 c-2.7,0.1-5.5,0.2-8.4,0.1c-26.8-1-46.4-13.7-55.2-20.4c-3.6-2.8-7.8-6.5-11.9-11.3c-5.8-6.9-9.4-13.6-11.7-18.8 c11,9.3,21.6,15.5,30.2,19.7c3.5,1.7,6.7,3,9.5,4.1c5.3,2,10.4,4,16.2,5.2c4.2,0.9,8.7,1.4,13.8,1.3c3.8-0.1,10.3-0.3,17.5-2.7 c4.1-1.3,8.5-3.4,12.7-6.6c4-3,6.8-6.1,8.5-8.4l35.9,7.6C342.6,697.2,358.9,676.3,359.4,675.6z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 84,
    xlinkHref: "53F4F677.png",
    transform: "matrix(0.8847 0 0 1 -511.3929 623.5321)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-537.3,854.1l-0.9,17.1h-18.2v70.5c-13.9-2.8-24.8-8.7-31.7-13.5V808.6l31.1,6.6v38.9H-537.3z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 84,
    xlinkHref: "53F4F67A.png",
    transform: "matrix(0.8847 0 0 1 -611.6786 878.1036)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-603.6,914.6c3.5,4.3,7.1,7.6,10.2,10c1.1,0.9,2.5,2,4.1,3.1c6.9,4.8,17.6,11,31.5,13.9 c3.8,0.8,7.8,1.3,12.1,1.5c7.9,0.4,14.7-0.4,20.5-1.6c7.2-1.2,17.2-3.9,27.7-9.9c21.8-12.7,31.5-32.1,34.9-40.1 c0,0-14.7,18.4-25.7,26l1.8-119.7c-6.9-4.9-17.6-11-31.5-14l-1.1,70.5l-18.2-0.3l-1.2,17.1l19.7,0.3l-0.6,38.9 c-1.6,2-4,4.7-7.5,7.3c-10.2,7.3-21.2,7.6-26.4,7.7c-1.5,0-2.9,0-4.3-0.2c-8.4-0.6-14.9-3.1-21.7-5.9c-2.8-1.2-6.2-2.6-9.9-4.6 c-7.1-3.6-15.6-9-24.4-16.6C-611.7,902.7-608.6,908.6-603.6,914.6z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-503.3,661c3.5,4.3,7.2,7.5,10.3,9.8c1.1,0.9,2.5,1.9,4.1,3c7,4.7,17.8,10.7,31.7,13.4 c3.8,0.7,7.9,1.2,12.1,1.3c7.9,0.3,14.7-0.6,20.4-1.9c7.2-1.3,17.1-4.1,27.5-10.3c21.6-13,31.1-32.6,34.3-40.6 c0,0-14.4,18.6-25.3,26.4l0-119.7c-7-4.8-17.8-10.7-31.7-13.5v70.6H-438l-0.9,17.1h19.7v38.9c-1.6,2-4,4.8-7.4,7.4 c-10.1,7.5-21.1,7.9-26.3,8.1c-1.5,0-2.9,0-4.3-0.1c-8.4-0.4-15-2.9-21.8-5.5c-2.8-1.1-6.2-2.5-10-4.4 c-7.2-3.5-15.7-8.8-24.6-16.2C-511.5,649.2-508.4,655.1-503.3,661z"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 84,
    xlinkHref: "53F4F67B.png",
    transform: "matrix(0.8847 0 0 1 -544.1436 764.4734)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-462.8,826c-8.9-7.5-17.4-12.7-24.6-16.2c-3.7-1.9-7.1-3.3-10-4.4c-6.8-2.6-13.4-5.1-21.8-5.5 c-1.3-0.2-2.8-0.2-4.3-0.2c-5.2,0.2-16.2,0.6-26.3,8.1c-3.4,2.6-5.8,5.4-7.4,7.4l-31.1-6.6c-10.7,7.7-24.8,25.8-25.3,26.4 c3.2-8,12.7-27.6,34.3-40.6c10.4-6.2,20.3-9,27.5-10.3c5.7-1.3,12.6-2.2,20.4-1.9c4.3,0.2,8.3,0.6,12.1,1.3 c13.9,2.7,24.8,8.7,31.7,13.4c1.6,1,3,2.1,4.1,3c3.2,2.3,6.8,5.5,10.3,9.8C-467.9,815.7-464.8,821.6-462.8,826z"
  })), /*#__PURE__*/React.createElement("g", null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,445.5l-0.4,7.1h-7.5v29.2c-5.8-1.1-10.3-3.6-13.1-5.6v-49.6l12.9,2.7v16.1H187.3z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 84,
    xlinkHref: "53F4F67D.png",
    transform: "matrix(0.3665 0 0 0.4143 156.5184 455.4238)"
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.8,470.6c1.4,1.8,2.9,3.1,4.2,4.1c0.5,0.4,1,0.8,1.7,1.3c2.9,2,7.3,4.5,13.1,5.7c1.6,0.3,3.2,0.5,5,0.6 c3.3,0.2,6.1-0.2,8.5-0.6c3-0.5,7.1-1.6,11.5-4.1c9-5.3,13.1-13.3,14.5-16.6c0,0-6.1,7.6-10.6,10.8l0.8-49.6 c-2.9-2-7.3-4.5-13.1-5.8l-0.4,29.2l-7.5-0.1l-0.5,7.1l8.2,0.1l-0.2,16.1c-0.7,0.8-1.7,2-3.1,3c-4.2,3-8.8,3.2-10.9,3.2 c-0.6,0-1.2,0-1.8-0.1c-3.5-0.2-6.2-1.3-9-2.4c-1.2-0.5-2.6-1.1-4.1-1.9c-3-1.5-6.5-3.7-10.1-6.9 C156.5,465.6,157.8,468.1,159.8,470.6z"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 92,
    height: 84,
    xlinkHref: "22679DC6.png",
    transform: "matrix(0.3665 0 0 0.4143 184.4959 408.3506)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.2,433.9c-3.7-3.1-7.2-5.3-10.2-6.7c-1.5-0.8-2.9-1.4-4.1-1.8c-2.8-1.1-5.6-2.1-9-2.3 c-0.6-0.1-1.1-0.1-1.8-0.1c-2.1,0.1-6.7,0.2-10.9,3.3c-1.4,1.1-2.4,2.2-3.1,3.1l-12.9-2.7c-4.4,3.2-10.3,10.7-10.5,10.9 c1.3-3.3,5.2-11.4,14.2-16.8c4.3-2.6,8.4-3.7,11.4-4.3c2.4-0.5,5.2-0.9,8.5-0.8c1.8,0.1,3.4,0.2,5,0.6c5.8,1.1,10.3,3.6,13.1,5.6 c0.7,0.4,1.2,0.9,1.7,1.2c1.3,1,2.8,2.3,4.3,4.1C216.1,429.6,217.4,432,218.2,433.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogocolor);
export default __webpack_public_path__ + "static/media/Mylogocolor.a99721e688315336a3dbc184f13591c9.svg";
export { ForwardRef as ReactComponent };